import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery'

class Webhosting extends Component {
    componentDidMount(){


        function resetMenu(){
            $("#home a").removeClass("active");

            $("#sluzby-a-produkty-link").removeClass("active");
            $("#prodej-instalace-li").removeClass("active");
            $("#lokalni-li").removeClass("active");
            $("#outsourcing-li").removeClass("active");
            $("#audit-is-li").removeClass("active");
            $("#webhosting-li").removeClass("active");
            $("#webdesign-li").removeClass("active");
            $("#cenik-praci-li").removeClass("active");

            $("#o-firme-li a").removeClass("active");
            $("#reference-li a").removeClass("active");
            $("#kontakty-li a").removeClass("active");
            $("#podpora-li a").removeClass("active");
        }

        resetMenu();

        $("#webhosting-li").addClass("active");
        $("#basic-nav-dropdown").addClass("active");


    }
  render() {
    return (
<div>


        <div className="container content fade-in two" id="webhosting">

            <span>
                <h1>Webhosting -  internetové služby</h1>

                   <h2> Co je webhosting?</h2>
                    Mít webové stránky nestačí. Aby je mohli navštěvovat lidé z celého světa, neobejdete se bez služby webhosting. Ta zajistí  prostor pro vaši webovou prezentaci  a zpřístupní ji všem uživatelům internetu.
<br/><br/>
                     <h2>Chcete webhosting?</h2>
                Postup je jednoduchý. Vyberete si některý z našich připravených <Link to="/sluzby-a-produkty/cenik-praci-a-sluzeb">cenových programů</Link> pro Váš webhosting a do poskytnutého prostoru můžete umisťovat své texty, obrázky, fotografie či videa, případně provozovat internetový obchod. O fungování a zveřejnění Vašeho webu na celosvětové síti se už <b>postaráme my</b>.
<br/><br/>
                    <h2>Kvalita, dostupnost, technická podpora</h2>
                <b>Levný webhosting</b> zdaleka neznamená ztrátu kvality ve prospěch nízké ceny. Za kvalitou služeb pro webhosting si stojíme a nabízíme našim zákazníkům <b>maximální komfort obsluhy</b> a minimální měsíční <b>dostupnost serverů 99,5%</b>. Věříme, že dokážeme uspokojit všechny české i zahraniční zákazníky, kteří hledají <b>levný webhosting</b> s bezkonkurenční kvalitou. Samozřejmou součástí našich služeb je <b>vstřícná technická podpora</b>, která zajistí, že případné problémy budou vyřešeny bezodkladně a bez zbytečných ztrát pro zákazníka. Při zprávě domén velice úzce spolupracujeme se společností Arachne Labs a SPOJE.NET, jako registrátora využíváme služeb společnosti FORPSI – INTERNET CZ, a.s.
<br/><br/>
                <h2> Naše firma Vám nabízí tyto služby:</h2>

                    <h2>Domény</h2>
                    <li>registrace domén cz, eu, com, net a další</li>
                    <li>změna technického subjektu, změna majitele domény, změna registrátora</li>
                    <li>změna DNS, držení primárních i sekundárních DNS v systému</li>
<br/><br/>
                    <h2>Webhosting</h2>
                    <li>PHP, MySQL</li>
                    <li>statistiky webu</li>
                        <ul>
                                <li>denní statistika, měsíční a roční srovnávací statistika</li>
                                <li>jedinečné IP adresy návštěvníků, objem přenesných dat</li>
                                <li>druh prohlížeče, klíčová slova</li>
                        </ul>
                <br/>
                <h2>Hosting mail serveru</h2>

                <li>IMAP, POP3,SMTP, chráněné antivirem, antispamem, webové rozhraní  webmail</li>
<br/><br/>
                <h2>FTP, Serverhosting, denní zálohování</h2>

            </span>
        </div>


</div>
    );
  }
}

export default Webhosting;



// WEBPACK FOOTER //
// ./src/sluzby-a-produkty/Webhosting.js